import { ATTRIBUTES_ENDPOINT } from '@/constants/endpoints';
import { typedHttp } from '@/modules/http';
import { type RequestConfig } from '@/modules/http/types';

export async function fetchProductAttributes(config?: RequestConfig) {
  return await typedHttp.get(ATTRIBUTES_ENDPOINT, config);
}
